import React from 'react';

import Head from 'next/head';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Terms from '@/components/Terms';

const Home = () => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>
    </Head>
    <Header />
    <Terms />
    <Footer />
  </div>
);

export default Home;
